import { render, staticRenderFns } from "./myquotas.vue?vue&type=template&id=5fbaeab8&"
import script from "./myquotas.vue?vue&type=script&lang=js&"
export * from "./myquotas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports